/* eslint-disable react/display-name */
import React from 'react';
import { OptionProps } from 'react-select';

import * as Interfaces from '../interfaces';
import * as Styled from '../styled';

const Option: (
  props: Interfaces.SelectComponentProps
) => React.FC<OptionProps<Interfaces.OptionType>> = ({ inputValue = '' }) => ({
  innerProps,
  ...rest
}) => {
  const { label, isFocused } = rest;

  const startIndex = label.toLowerCase().indexOf(inputValue.toLowerCase());
  const endIndex = startIndex + inputValue.length;

  const patternMatch = (
    <>
      {label.substring(0, startIndex)}
      <strong>{label.substring(startIndex, endIndex)}</strong>
      {label.substring(endIndex)}
    </>
  );

  return (
    <Styled.Option {...innerProps} isFocused={isFocused}>
      {startIndex >= 0 ? patternMatch : label}
    </Styled.Option>
  );
};

export default Option;
